module.exports = __webpack_public_path__ + "img/vertical-logo-strip.bbfe0d10.png";